module.exports = __webpack_public_path__ + "static/media/md-rewind.5a79fae9.svg";